import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'
import { usePositionStorage } from '../hooks'
import { AuthLayout, SignInForm } from '../ui'

const authSearchSchema = z.object({
	position: z.string().optional(),
	redirect: z.string().optional(),
})

export const Route = createFileRoute('/auth')({
	validateSearch: authSearchSchema,
	component: RouteComponent,
})

function RouteComponent() {
	const search = Route.useSearch()
	const { savePosition } = usePositionStorage()

	useEffect(() => {
		if (search.position) {
			savePosition(search.position)
		}
	}, [search.position, savePosition])

	return (
		<AuthLayout>
			<SignInForm />
		</AuthLayout>
	)
}
